"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateLocaleCode = validateLocaleCode;
exports.validateLocaleData = validateLocaleData;
exports.validateLocales = validateLocales;
exports.validateNgettextMsgid = validateNgettextMsgid;
exports.validateNgettextNumber = validateNgettextNumber;
exports.validateNgettextPluralForms = validateNgettextPluralForms;
exports.validateLang = validateLang;

var _minimal = require("plural-forms/dist/minimal");

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function validateLocale(locale, availLocales) {
  if (process.env.NODE_ENV !== 'production') {
    if (!availLocales[locale]) {
      throw new Error("\n                    Locale '".concat(locale, "' is not found in config.\n                    useLocales accepts only existing locales. Use addLocale function before.\n                    Available locales: ").concat(JSON.stringify(availLocales)));
    }
  }
}

function validateLocaleCode(locale) {
  if (process.env.NODE_ENV !== 'production') {
    if (typeof locale !== 'string') {
      throw new Error("Expected locale code to be a string but recieved ".concat(_typeof(locale), " insttead"));
    }
  }
}

function validateLocaleData(data) {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line
    var addLocaleDoc = 'https://c-3po.js.org/configuration-c-3po-lib.html#addlocale-string-locale-object-data-bool-replacevariablesnames';

    if (!data) {
      throw new Error("\n            Locale data sould not be empty.\n            see - ".concat(addLocaleDoc, "\n            "));
    }

    if (!data.headers) {
      throw new Error("\n            Locale data sould contain headers \"".concat(JSON.stringify(data), "\".\n            see - ").concat(addLocaleDoc, "\n            "));
    }

    if (!data.headers['plural-forms'] && !data.headers['Plural-Forms']) {
      throw new Error("\n            Locale data.headers should contain 'Plural-Forms' attribute \"".concat(JSON.stringify(data), "\".\n            see - ").concat(addLocaleDoc, "\n            "));
    }

    if (!data.translations) {
      throw new Error("\n            Locale data sould contain translations \"".concat(JSON.stringify(data), "\".\n            see - ").concat(addLocaleDoc, "\n            "));
    }

    if (!Object.keys(data.translations).length) {
      throw new Error("\n            Locale data.translations should have at least 1 key\"".concat(JSON.stringify(data), "\".\n            see - ").concat(addLocaleDoc, "\n            "));
    }
  }
}

function validateLocales(locales, availLocales) {
  if (process.env.NODE_ENV !== 'production') {
    if (!Array.isArray(locales)) {
      throw new Error('useLocales accepts only array as the first argument');
    }

    locales.forEach(function (locale) {
      return validateLocale(locale, availLocales);
    });
  }
}

function validateNgettextMsgid(str) {
  if (process.env.NODE_ENV !== 'production') {
    var ngettextDoc = 'https://c-3po.js.org/ngettext.html#usage';

    if (!(str.hasOwnProperty('_strs') && str.hasOwnProperty('_exprs'))) {
      throw new Error("The first argument for ngettext must be tagged with 'msgid' tag.\n                see - ".concat(ngettextDoc, ";\n                "));
    }
  }
}

function validateNgettextNumber(n) {
  if (process.env.NODE_ENV !== 'production') {
    var ngettextDoc = 'https://c-3po.js.org/ngettext.html#usage';

    if (!(typeof n === 'number')) {
      throw new Error("The last argument to ngettext - '".concat(n, "' expected to be a number. Got '").concat(_typeof(n), "' instead.\n                see - ").concat(ngettextDoc));
    }
  }
}

function validateNgettextPluralForms(expectedFormsCount, actualFormsCount) {
  if (process.env.NODE_ENV !== 'production') {
    if (actualFormsCount !== expectedFormsCount) {
      throw new Error( // eslint-disable-next-line max-len
      "ngettext expects ".concat(expectedFormsCount, " for the current default locale, but received - ").concat(actualFormsCount, "."));
    }
  }
}

function validateLang(lang) {
  if (process.env.NODE_ENV !== 'production') {
    var langs = (0, _minimal.getAvailLangs)().join(',');

    if (!(0, _minimal.hasLang)(lang)) {
      throw new Error("Unknown lang code - ".concat(lang, ". Lang should be one of: ").concat(langs, "."));
    }
  }
}